import { Download } from "lucide-react";
import { BROCHURE_URL } from "@/data/content";

/**
 * Reusable download card for the partnership brochure PDF.
 * Used on the Enroll and Become-a-Tutor pages.
 */
export function BrochureCTA({ label = "Partnership Brochure", eyebrow = "Downloadable", note = "PDF · one-pager overview of PBL-TDLE, Concept Labs, CoPE-App and partnership options.", testid = "brochure-cta" }) {
  return (
    <div
      className="rounded-2xl border border-white/10 p-6 md:p-8 flex flex-col md:flex-row md:items-center justify-between gap-6 text-onimg"
      style={{ background: "linear-gradient(120deg,#0B1B30 0%, #1B4A7A 55%, #2E6BB0 100%)" }}
      data-testid={testid}
    >
      <div className="min-w-0">
        <div className="font-mono-label text-[11px] tracking-label uppercase text-white/70">{eyebrow}</div>
        <h3 className="font-display text-xl md:text-2xl text-onimg mt-2 tracking-tight leading-tight">{label}</h3>
        <p className="text-onimg/85 text-sm mt-2 max-w-lg">{note}</p>
      </div>
      <a
        href={BROCHURE_URL}
        download
        target="_blank"
        rel="noreferrer"
        data-testid={`${testid}-link`}
        className="inline-flex items-center gap-2 bg-white text-[#0B1F33] px-6 py-3.5 rounded-full font-mono-label text-[11px] tracking-label uppercase hover:gap-3 transition-all shrink-0"
      >
        <Download className="w-4 h-4" /> Download PDF
      </a>
    </div>
  );
}

export default BrochureCTA;
